(function() {
  var Controller, Socket,
    bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  Controller = App.loadClass('core::Angular/Controller');

  Socket = require('resources/assets/coffee/Core/Socket').Socket;

  exports.SafeLinkController = (function(superClass) {
    extend(SafeLinkController, superClass);

    function SafeLinkController(scope, transitions, service, session) {
      this.scope = scope;
      this.transitions = transitions;
      this.service = service;
      this.session = session;
      this.handleViewingUser = bind(this.handleViewingUser, this);
      this.loadSafeLink = bind(this.loadSafeLink, this);
      this.loadCompany = bind(this.loadCompany, this);
      this.loadAccessUser = bind(this.loadAccessUser, this);
      SafeLinkController.__super__.constructor.apply(this, arguments);
      this.scope.safeLinkSearch = '';
      this.scope.users = [];
      this.scope.login_user = null;
      this.scope.linked_user = null;
      this.scope.loadSafeLink = this.loadSafeLink;
      this.scope.handleViewingUser = this.handleViewingUser;
      this.loadAccessUser();
      this.loadCompany();
      this.scope.loadSafeLink(false);
    }

    SafeLinkController.prototype.loadAccessUser = function() {
      return this.service.loadAccessUser().then((function(_this) {
        return function(response) {
          _this.scope.login_user = response.data.data.authUser;
          _this.scope.linked_user = response.data.data.safeLinkUser;
          _this.handleViewingUser(_this.scope.linked_user, false);
          return App.is_safelinking = _this.scope.login_user.id !== _this.scope.linked_user.id;
        };
      })(this));
    };

    SafeLinkController.prototype.loadCompany = function() {
      return this.service.loadCompany().then((function(_this) {
        return function(response) {
          return _this.scope.company = response.data.internal_name;
        };
      })(this));
    };

    SafeLinkController.prototype.loadSafeLink = function(append, e) {
      return this.service.loadSafeLink(this.scope.safeLinkSearch, append).then((function(_this) {
        return function(response) {
          var jsr;
          jsr = response.data;
          if (append) {
            return _this.scope.users = _this.scope.users.concat(jsr.data.users);
          } else {
            return _this.scope.users = jsr.data.users;
          }
        };
      })(this));
    };

    SafeLinkController.prototype.handleViewingUser = function(user, reload_page) {
      if (reload_page == null) {
        reload_page = true;
      }
      if (reload_page) {
        window.dispatchEvent(new Event('app:safelinking'));
      }
      if (user === null) {
        App.addPopup('NonExistentUserDialog');
      }
      this.scope.linked_user = user;
      return this.service.fetchPermissions(user.id).then((function(_this) {
        return function(response) {
          var jsr, navLinks, options, permissions, ref, ref1, ref2, ref3, ref4, ref5, ref6, rootScope, token;
          jsr = response.data;
          if (jsr.status.type === 'success') {
            $('#ws_user_id').val(user.id);
            permissions = (ref = jsr.data) != null ? ref.permissions : void 0;
            token = (ref1 = jsr.data) != null ? ref1.token : void 0;
            navLinks = $('#nav_primary_links').children('li');
            options = {
              animation: true,
              placement: 'bottom',
              title: "You do not have access to view this part of the currently selected user's account",
              trigger: 'hover',
              delay: 0
            };
            if (!permissions) {
              _this.session.set('SafeLink', _this.session.get('Authorization'));
              App.is_safelinking = false;
              navLinks.each(function() {
                if ($(this).hasClass('disable-aye-czar')) {
                  $(this).removeClass('disable-aye-czar');
                  $(this).tooltip('destroy');
                  return $(this).unbind('hover');
                }
              });
              if (reload_page) {
                rootScope = (ref2 = angular.element('body').scope()) != null ? ref2.$root : void 0;
                if (rootScope != null) {
                  rootScope.$broadcast('app:safelinked');
                }
                window.dispatchEvent(new Event('app:safelinked'));
                return (ref3 = App.current_page) != null ? ref3.refresh() : void 0;
              }
            } else {
              _this.session.set('SafeLink', "Bearer " + token);
              App.is_safelinking = true;
              navLinks.each(function() {
                var pname, ref4;
                if ($(this).hasClass('disable-aye-czar')) {
                  $(this).removeClass('disable-aye-czar');
                  $(this).tooltip('destroy');
                  $(this).unbind('hover');
                }
                pname = (ref4 = $(this).data('permission-name')) != null ? ref4 : $(this).find('a').eq(0).text().trim();
                if (pname !== 'Profile' && pname !== 'More') {
                  if (!permissions[pname]) {
                    if ($(this).hasClass('active')) {
                      setTimeout(function() {
                        return $('a[ui-sref="grower.fields"]').trigger('click');
                      }, 0);
                    }
                    $(this).addClass('disable-aye-czar');
                    return $(this).tooltip(options);
                  } else if ($(this).hasClass('active')) {
                    if (reload_page) {
                      return setTimeout(function() {
                        return $(this).find('a').trigger('click');
                      }, 0);
                    }
                  }
                }
              });
              if (reload_page) {
                rootScope = (ref4 = angular.element('body').scope()) != null ? (ref5 = ref4.$root) != null ? ref5.$broadcast('app:safelinked') : void 0 : void 0;
                window.dispatchEvent(new Event('app:safelinked'));
              }
              return (ref6 = App.current_page) != null ? ref6.refresh() : void 0;
            }
          }
        };
      })(this));
    };

    return SafeLinkController;

  })(Controller);

}).call(this);
